import React from 'react'
const Footer = () => {
  return (
    <div className='footer'>

      <a target='_blank' href="https://www.linkedin.com/in/deja-flynn-991058192/">Linkedin</a>
      <a target='_blank' href="https://github.com/DejaLFlynn?tab=repositories">Git Hub</a>
    </div>
  )
}

export default Footer